var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Lib from "@core/libs";
/**
 * Example of TC Javascript library which is kind of a partial View
 *
 * IMPORTANT! Each lib MUST be registered for an application
 * by returning it in Application.getLibs()
 */
var ExampleLib = /** @class */ (function (_super) {
    __extends(ExampleLib, _super);
    function ExampleLib() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Called when library is mounted
     * At this point you can access the DOM
     */
    ExampleLib.prototype.onMounted = function () {
        console.log('ExampleLib mounted.');
        // Just a simple example
        var output = this.el.querySelector('.js-lib-status');
        output.textContent = 'Loaded';
    };
    return ExampleLib;
}(Lib));
export default ExampleLib;
